<template>
    <rkm-row>
        <rkm-col>
            <rkm-row>
                <rkm-col cols="12">
                    <BoxMotivoAtendimento :item="item" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxAntropometria :data="item.antropometria" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxSinalVital :data="item.sinalVital" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxGlicemiaCapilar :data="item.glicemiaCapilar" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxProcedimento :item="item" />
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="item.classificacaoRisco">
                <rkm-col cols="12">
                    <BoxClassificacaoRisco :item="item" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxDeclaracaoComparecimento :item="item" />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxInformacaoAdministrativa :item="item" />
                </rkm-col>
            </rkm-row>
        </rkm-col>
    </rkm-row>
</template>

<script>
// Components.
import BoxAntropometria from '@/components/ambulatorio/atendimento/components/historico/components/antropometria/Index'
import BoxClassificacaoRisco from './components/classificacao-risco/Index'
import BoxDeclaracaoComparecimento from './components/declaracao-comparecimento/Index'
import BoxGlicemiaCapilar from '@/components/ambulatorio/atendimento/components/historico/components/glicemia-capilar/Index'
import BoxInformacaoAdministrativa from './components/informacao-administrativa/Index'
import BoxMotivoAtendimento from './components/motivo-atendimento/Index'
import BoxProcedimento from './components/procedimento/Index'
import BoxSinalVital from '@/components/ambulatorio/atendimento/components/historico/components/sinal-vital/Index'

export default {
    components: {
        BoxAntropometria,
        BoxClassificacaoRisco,
        BoxDeclaracaoComparecimento,
        BoxGlicemiaCapilar,
        BoxInformacaoAdministrativa,
        BoxMotivoAtendimento,
        BoxProcedimento,
        BoxSinalVital,
    },
    props: {
        item: {type: Object, required: true},
    },
}
</script>